import React from 'react';
export default function RFCoinPage() {
  return (<div style={{ height: 'calc(100vh - 56px)', paddingBottom: 80 }}>
    <iframe src="https://token.richfactory.org/" title="RF Coin" style={{ width: '100%', height: '100%', border: 'none', background: '#060B1A' }} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope" />
  </div>);
}
